import axios from 'axios';
import { router } from '../router/index';
import {Toast} from 'vant';
// 统一请求路径前缀
// let base = '/dcf';
//let base = '/manage';
let base = '';
// 超时设定
axios.defaults.timeout = 15000;

let sgasession=localStorage.getItem('sgasession')


axios.interceptors.request.use(config => {
    return config;
}, err => {
    Toast.error('请求超时');
    //return Promise.reject(err);
	return Promise.resolve(err.response);
});

// http response 拦截器
axios.interceptors.response.use(response => {
    const data = response.data;
    // 根据返回的code值来做不同的处理(和后端约定)
    switch (data.code) {
        case 401:
            // 未登录 清除已登录状态
            router.push('/login');
            break;
        case 403:
            // 没有权限
            if (data.message !== null) {
                Toast.error(data.message);
            } else {
                Toast.error("未知错误");
            }
            break;
        case 500:
			debugger;
            // 错误
            if (data.message !== null) {
                Toast.error('+++++++++++++++++++',data.message);
            } else if(data.message=='Access Token 已经过期'){	
				//去掉cookie信息 存储页面信息
					let formpath=window.location.href
					//跳转到用户中心登录				
					location.href="http://10.240.46.7:7098/login"				
			}
			else {
                Toast.error("未知错误");
            }
            break;
		case 1004:
			// 未登录 清除已登录状态
			router.push('/login');
			break;
        default:
            return data;
    }

    return data;
}, err => {
	let errMsg="";
	console.log('err.response',err.response)
    if (err && err.response) {
        switch (err.response.status) {
            case 400: errMsg = err.response.data.msg ; break;
            case 401: errMsg = '未授权，请重新登录(401)'; break;
            case 403: errMsg = '拒绝访问(403)'; break;
            case 404: errMsg = '请求出错(404)'; break;
            case 408: errMsg = '请求超时(408)'; break;
            case 500: 
				errMsg = '服务器错误(500):'+err.response.data.msg;
				if(err.response.data.msg=='Access Token 已经过期'){
					//去掉cookie信息 存储页面信息
						let formpath=window.location.href
						//跳转到用户中心登录				
						location.href="http://10.240.46.7:7098/login"
					
				}
			 break;
            case 501: errMsg = '服务未实现(501)'; break;
            case 502: errMsg = '网络错误(502)'; break;
            case 503: errMsg = err.response.data.msg; break;
            case 504: errMsg = '网络超时(504)'; break;
            case 505: errMsg = 'HTTP版本不受支持(505)'; break;
            default : errMsg = `连接出错(${err.response.status})!`;
        }
    }else{
        errMsg = '连接服务器失败!'
    }
	
    Toast.error(errMsg);
    //return Promise.reject(err);
	let data = {status:500,result:"",success:false,message:errMsg,code:1};
	return Promise.resolve(data);// 可在组件内获取到服务器返回信息
});

export const getRequest = (url, params) => {
	let sgasession=localStorage.getItem('sgasession')
    return axios({
        method: 'get',
        url: `${base}${url}`,
        params: params,
        headers: {
			'sgasession':sgasession,
			'content-type': 'application/x-www-form-urlencoded',
			'api-serviceId':'1526494863636434944',
			'api-appid':'1514893127704514560',
        }
    });
};




//Json方式，后台接收可以使用@RequestsBody接收
export const postJsonRequest = (url, params) => {
  return axios({
    method: 'post',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
	  'sgasession':sgasession
    },
  });
};


//表单方式
export const postRequest = (url, params) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
            }
            ret = ret.substring(0, ret.length - 1);
			
            return ret;
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
			'sgasession':sgasession
        }
    });
};
//post 图片
export const postRequestimg = (url, params) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        headers: {
            'Content-Type': 'multipart/form-data',
			'sgasession':sgasession
        }
    });
};

//Json方式，后台接收可以使用@RequestsBody接收
export const putJsonRequest = (url, params) => {
  return axios({
    method: 'put',
    url: `${base}${url}`,
    data: params,
    headers: {
      'Content-Type': 'application/json',
	  'sgasession':sgasession
    },
  });
};

//表单方式，后台接收不能使用@RequestsBody接收
export const putRequest = (url, params) => {
    return axios({
        method: 'put',
        url: `${base}${url}`,
        data: params,
        transformRequest: [function (data) {
            let ret = '';
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&';
            }
            ret = ret.substring(0, ret.length - 1);
            return ret;
        }],
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
			'sgasession':sgasession
        }
    });
};

export const deleteRequest = (url, params) => {
    return axios({
        method: 'delete',
        url: `${base}${url}`,
        params: params,
        headers: {
			'sgasession':sgasession
        }
    });
};

export const uploadFileRequest = (url, params) => {
    return axios({
        method: 'post',
        url: `${base}${url}`,
        params: params,
        headers: {
			'sgasession':sgasession
        }
    });
};

/**
 * 无需token验证的请求 避免旧token过期导致请求失败
 * @param {*} url 
 * @param {*} params 
 */
export const getRequestWithNoToken = (url, params) => {
    return axios({
        method: 'get',
        url: `${base}${url}`,
        params: params
    });
};

export const downLoadFileRequest=(url,params)=>{
	return axios({
	    method: 'get',
	    url: `${base}${url}`,
	    params: params,
		responseType: 'blob',
	    headers: {
			'sgasession':sgasession
	    }
	});
};
